import React from 'react'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { isMobile } from '../../../helpers'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import { connect } from 'react-redux'
import { breakpoints } from '../../../constants'
import { BLUE, LIGHTGRAY } from '../../../styles/colors.style'
import { mapCardBrandToIcon } from './../../../components/credit-cards/credit-cards-list.component'
import { StyledContent } from '../../../components/form-components/payment-fields/styled-content.style'
import MuvicardLogo from '../../../../../client/assets/images/logo-muvicard.png'
import PixLogo from '../../../../../client/assets/images/logo-pix.png'
import { PAYMENT_METHODS } from '../../../constants'

class PaymentDataConfirmationComponent extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			user,
			cardBrand,
			installmentsQtt,
			muvicardLimit,
			lastFourNumbers,
			totalPointsOnTicketSale,
			paymentMethod,
			calculatedValues,
		} = this.props

		const isPublicBody = user && user.hasPublicBody

		const { totalInterest, totalOrderValue } = calculatedValues

		const showInterest =
			totalInterest > 0.04 &&
			(paymentMethod === PAYMENT_METHODS.MUVICARD ||
				paymentMethod === PAYMENT_METHODS.CREDIT_CARD)

		let totalOrderValueWithInterestValue = totalOrderValue

		if (!isPublicBody && showInterest) {
			totalOrderValueWithInterestValue = totalInterest + totalOrderValue
		}

		const hasInstallments = installmentsQtt > 1

		const installmentsText = hasInstallments
			? `Parcelamento em ${installmentsQtt}x de ${(
					totalOrderValueWithInterestValue / installmentsQtt
			  ).$toReais()}`
			: 'A vista'

		return (
			<StyledContainer className="f-large">
				{paymentMethod == PAYMENT_METHODS.MUVICARD ? (
					<div className="row d-block">
						<img src={MuvicardLogo} alt="Muvicard" />
						<p>
							<b>Limite disponível: {muvicardLimit.$toReais()}</b>
						</p>
					</div>
				) : null}

				{paymentMethod == PAYMENT_METHODS.CREDIT_CARD ? (
					<div className="row card-container">
						{mapCardBrandToIcon(cardBrand)}
						<StyledLastFourNumbers>
							{lastFourNumbers}
						</StyledLastFourNumbers>
					</div>
				) : null}

				{paymentMethod == PAYMENT_METHODS.BANKSLIP ? (
					<div className="row">
						<StyledContent>
							<FontAwesome
								name="barcode"
								size={isMobile() ? '2x' : '4x'}
							/>
							<div>Boleto</div>
						</StyledContent>
					</div>
				) : null}

				{paymentMethod == PAYMENT_METHODS.PIX ? (
					<div className="row d-block">
						<img src={PixLogo} alt="Pix" />
					</div>
				) : null}

				<div className="total-value">
					<div className="space-beetween">
						<span>Subtotal</span>
						<span id="order-subtotal">{totalOrderValue.$toReais()}</span>
					</div>
					{!isPublicBody && showInterest ? (
						<div className="space-beetween">
							<span>Juros</span>
							<span id="order-servicecharge">
								{totalInterest.$toReais()}
							</span>
						</div>
					) : null}
					<div className="space-beetween total">
						<span>Valor à {hasInstallments ? 'prazo' : 'vista'}</span>
						<div>
							{totalPointsOnTicketSale > 0 && (
								<span id="order-totalpoints">
									{totalPointsOnTicketSale.toLocaleString('pt-BR')}{' '}
									pts&nbsp;+&nbsp;
								</span>
							)}
							<span id="order-totalvalue">
								{totalOrderValueWithInterestValue.$toReais()}
							</span>
						</div>
					</div>
					{hasInstallments ? (
						<div className="f-medium right">
							<span className="f-medium">{installmentsText}</span>
						</div>
					) : null}
				</div>
			</StyledContainer>
		)
	}
}

const StyledLastFourNumbers = styled.span`
	margin-left: 1rem;
`

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	img {
		width: auto;
		max-height: 50px;
	}

	.row {
		display: flex;
		justify-content: space-between;
		img {
			width: auto;
			max-height: 50px;
		}
	}
	.d-block {
		display: block;
	}

	.card-container {
		align-items: center;
	}

	.card-icon {
		max-width: 51px;
		outline: 1px solid ${BLUE};

		img {
			width: 100%;
			max-height: 35px;
		}
	}

	.space-beetween {
		display: flex;
		justify-content: space-between;
	}

	.total {
		border-top: 1px solid ${LIGHTGRAY};
		font-weight: bold;
		margin-top: 5px;
		padding-top: 5px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;

		.total-value {
			width: 38%;
		}
	}
`

const mapStateToProps = (store) => ({
	user: store.user,
	orderValue: store.ticketSale.orderValue,
	orderNumber: store.ticketSale.orderNumber,
	muvicardLimit: store.ticketSale.muvicardLimit,
	cardBrand: store.creditCardPurchase.cardBrand,
	paymentMethod: store.ticketSale.paymentMethod,
	discountLabel: store.ticketSale.discountLabel,
	discountValue: store.ticketSale.discountValue,
	discountPercent: store.ticketSale.discountPercent,
	totalPointsOnTicketSale: store.ticketSale.totalPointsOnTicketSale,
	installmentOptions: store.creditCardPurchase.installmentOptions,
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	tripPriceGoing: TicketSaleSelectors.getTripPriceGoing(store),
	tripPriceReturn: TicketSaleSelectors.getTripPriceReturn(store),
	serviceCharge: TicketSaleSelectors.getServiceChargeValue(store),
	lastFourNumbers: CreditCardPurchaseSelectors.getCardLastFourNumbers(
		store.creditCardPurchase
	),
	installmentsQtt: CreditCardPurchaseSelectors.getInstallmentsQtt(
		store.creditCardPurchase
	),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
})

const PaymentDataConfirmation = connect(mapStateToProps)(
	PaymentDataConfirmationComponent
)

export default PaymentDataConfirmation
